import { render, staticRenderFns } from "./productresult.vue?vue&type=template&id=168de011&"
import script from "./productresult.vue?vue&type=script&lang=js&"
export * from "./productresult.vue?vue&type=script&lang=js&"
import style0 from "./productresult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports